import React from "react";
import { useLocation } from "react-router-dom";
import PdfViewer from "./POViewer.jsx";
import { useNavigate } from "react-router-dom";
export default function PurchaseOrderDocuments() {
  const navigate = useNavigate();
  const location = useLocation();
  const documents = location.state?.documents || [];
  const vendorId = location.state?.vendorId;
  const handleViewStores = (POId) => {
    navigate(`/adminportal/vendorDetails/${vendorId}/stores/${POId}`);
  };

  return (
    <div className="h-[calc(100vh-50px)] overflow-auto">
      <PdfViewer
        mode="page"
        title="Purchase Orders"
        documents={documents}
        onViewStores={handleViewStores}
      />
    </div>
  );
}
